import { Routes } from '@angular/router';
import { isLoggedInGuard } from './services/guards/isLoggedIn.guard';

export const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./pages/pages.routes').then(m => m.PagesRoutes),
		canActivate: [isLoggedInGuard]
	},
	{
		path: 'login',
		loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
		// canActivate: [isLoggedInGuard]
	},
	{
		path: 'first-time-login',
		loadComponent: () => import('./auth/first-time-login/first-time-login.component').then(m => m.FirstTimeLoginComponent),
	},
	{
		path: 'forgot-password',
		loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
	},
	{
		path: 'reset-password',
		loadComponent: () => import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
	}
];

